import { QuestionBase } from './question-base.model';

export class EditGrid extends QuestionBase<string> {
    controlType = 'edit_grid';
    resource: any;
    data: any;
    visible: string;
    emitDataOnSubmit: any;
    constructor(options: {} = {}) {
        super(options);
        this.resource = options['resource'];
        this.data = options['data'];
        this.visible = (options['visible'] == undefined) ? true : options['visible'];
        this.value = options['data'];
        this.emitDataOnSubmit= options['emitDataOnSubmit'];
    }
}
